export const PDF_FONT_MAX_BYTES = 8 * 1024 * 1024;
export const PDF_FONT_MAX_MB = PDF_FONT_MAX_BYTES / (1024 * 1024);
export const PDF_FONT_URL = '/fonts/NotoSansTC-Regular.ttf';

export async function loadPdfFontBase64({
  fontUrl = PDF_FONT_URL,
  maxBytes = PDF_FONT_MAX_BYTES,
} = {}) {
  async function arrayBufferToBase64(buffer) {
    const blob = new Blob([buffer], { type: 'font/ttf' });
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || '');
        const base64 = result.includes(',') ? result.split(',')[1] : '';
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  try {
    const resp = await fetch(fontUrl);
    if (!resp || !resp.ok) {
      return null;
    }

    const contentLength = Number(resp.headers && resp.headers.get && resp.headers.get('content-length'));
    if (Number.isFinite(contentLength) && contentLength > maxBytes) {
      return null;
    }

    const arr = await resp.arrayBuffer();
    if (!arr || arr.byteLength === 0 || arr.byteLength > maxBytes) {
      return null;
    }

    return await arrayBufferToBase64(arr);
  } catch (e) {
    console.warn('loadPdfFontBase64 failed', e);
    return null;
  }
}
